import { put, takeLatest, call, spawn, all } from 'redux-saga/effects';
import { identityActions } from '../../../application/actions/identity';
import { loadingActions } from '../../../application/actions/ui_loaders';

import api from '../../api';

const apiIdentity = api(process.env.REACT_APP_IDENTITY_API);

export function* validateIdentity(action) {
  try {
    yield put(loadingActions.changeStatusLoadingValidateIdentity({ isLoading: true }));

    const { data, error } = yield call(apiIdentity.post, 'v1/validar', action.payload);
     if (data)
      yield all([
        put(identityActions.validateIdentitySuccess(data)),
        put(loadingActions.changeStatusLoadingValidateIdentity({ isLoading: false })),
      ]);
    else
      yield all([
        put(identityActions.validateIdentityError(error)),
        put(loadingActions.changeStatusLoadingValidateIdentity({ isLoading: false })),
      ]);
  } catch (err) {
    yield all([
      put(identityActions.validateIdentityError({ code: 500, message: err })),
      put(loadingActions.changeStatusLoadingValidateIdentity({ isLoading: false })),
    ]);
  }
}

export function* watchValidateIdentity() {
  yield takeLatest(identityActions.validateIdentity.type, validateIdentity);
}
/* istanbul ignore next */
export default function* identitySaga() {
  yield spawn(watchValidateIdentity);
}
